export default function Carte() {
  return (
    <section className="bg-brand-light">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pb-0 md:pb-0">
        <div className="rounded-xl overflow-hidden h-64 md:h-80 w-full border border-brand-border">
          <iframe
            title="Localisation Dépan'Volets Strasbourg"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2639.4!2d7.752111!3d48.573405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4796c84c0f0e8a23%3A0x8a0c0e0e0e0e0e0e!2s82%20Rue%20de%20Heidenberg%2C%2067200%20Strasbourg!5e0!3m2!1sfr!2sfr!4v1600000000000!5m2!1sfr!2sfr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
}